type SrcLike =
  | File
  | FileList
  | string
  | {
      name?: string;
      filename?: string;
      originalName?: string;
      url?: string;
      path?: string;
    }
  | null
  | undefined;

export const getFileName = (src: SrcLike): string => {
  if (!src) return "Документ";

  if (typeof FileList !== "undefined" && src instanceof FileList) {
    const f = src.item(0);
    return (f?.name ?? "Документ").replace(/^\./, "");
  }

  if (typeof File !== "undefined" && src instanceof File) {
    return (src.name ?? "Документ").replace(/^\./, "");
  }

  if (typeof src === "object") {
    const anySrc = src as any;
    const candidate =
      anySrc.name ||
      anySrc.filename ||
      anySrc.originalName ||
      anySrc.url ||
      anySrc.path;

    if (candidate && typeof candidate === "string") {
      return getFileName(candidate);
    }

    if (typeof Blob !== "undefined" && src instanceof Blob) {
      return "Документ";
    }

    return "Документ";
  }

  if (typeof src === "string") {
    let path = src;

    if (path.startsWith("data:")) {
      const m = path.match(/^data:([^;]+)/i);
      if (m) {
        const mime = m[1].toLowerCase();
        const ext = mime.split("/")[1] || "bin";
        return `file.${ext}`;
      }
      return "Документ";
    }

    if (path.startsWith("blob:")) {
      return "Документ";
    }

    path = path.replace(/\\/g, "/").replace(/\s+file$/i, "");

    const m = path.match(
      /[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}\.([^/]+)$/i
    );
    if (m) return m[1].replace(/^\./, "");

    const last = path.split("/").pop() || "";
    return last.replace(/^\./, "") || "Документ";
  }

  return "Документ";
};

export const getFileSize = (
  file: File | FileList | string | null | undefined
): string => {
  if (!file || typeof file === "string") return "";
  if (typeof FileList !== "undefined" && file instanceof FileList) {
    if (file.length === 0) return "";
    return prettySize(file[0].size);
  }
  return prettySize((file as File).size);
};

export const prettySize = (size: number): string => {
  return size < 1048576
    ? `${(size / 1024).toFixed(1)} KB`
    : `${(size / 1048576).toFixed(1)} MB`;
};
